export default __webpack_public_path__ + "static/CBA logo-4d203fe4f69bee98199366563e844cec.png";